<script>

import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';

import Calculator from '../../components/tank-management/calculator/Calculator.vue';
import OperationDetail from '../../components/tank-management/operations/OperationDetail.vue';
import config from '../../common/genericPanelConf';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'

export default{
    props: ['id'],
    components: {
        Accordion, AccordionTab, ResponsiveButton,
        Calculator, OperationDetail
    },
    created(){
        this.configuration = config.getConfiguration('TankOperations');
    },
    data(){
        return{
            activeIndex: 0,
            configuration: null,
        }
    },
    methods: {
        populateCalculator(data){
            this.$refs.calculator.populateInput(data);
            this.activeIndex = 1;
        },
        populateOperation(data, mode){
            this.$refs.operationDetail.populateOperation(data, mode, true);
            this.activeIndex = 0;
        },
        goBack(){
            this.$router.back();
        }
    }
}
</script>

<template>
    <main >
        <ResponsiveButton :label="$t('btn.back')" icon="pi pi-arrow-left" class="m-1 p-button-outlined p-button-sm" @click="goBack" />

        <Accordion :activeIndex="activeIndex">
            <AccordionTab :header="$t('tankCalculator.operation')">
                <OperationDetail ref="operationDetail" :id="id" @populate-calculator="populateCalculator"/>
            </AccordionTab>
            <AccordionTab :header="$t('tankCalculator.calculator')">
                <Calculator ref="calculator" @populate-operation="populateOperation"/>
            </AccordionTab>
        </Accordion>
    </main>
</template>